// extracted by mini-css-extract-plugin
export default {"autocomplete":"style_autocomplete__YodnN","item":"style_item__yUW6J"};